import { Component, Input, OnInit } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';

@Component({
  selector: 'app-form-my-gift-cards-card-preview',
  templateUrl: './form-my-gift-cards-card-preview.component.html',
  styleUrls: ['./form-my-gift-cards-card-preview.component.scss'],
})
export class FormMyGiftCardsCardPreviewComponent implements OnInit {
  @Input() giftCard: any = undefined;
  @Input() totalAmountForGiftCard = 0;
  public isPopoverOpen = false;
  constructor(public balanceSv: BalanceService) {}

  ngOnInit() {}
}
